import { ProgressStyled, TextStyled } from "../../styles/StageProgressBar";
import { Circle } from "./Circle";
import { useState, useEffect } from "react";
import { StagesData } from "../../Interfaces/IStages";
import axios from "axios";
import { ADVISER_IDENTIFIER, QUESTIONS_API_URL } from "../../env";
import styled from "styled-components";
import { T } from "../../styles/Theme";

interface IStageProgressBarProps {
  step: number;
  currentStep: number;
}

export const StageProgressBar = ({ currentStep }: IStageProgressBarProps) => {
  const [stage, setStage] = useState<StagesData[] | null>(null);
  const [percentage, setPercentage] = useState<number>(0);

  useEffect(() => {
    const url = `${QUESTIONS_API_URL}/${ADVISER_IDENTIFIER}/stages/`;
    axios.get(url).then((res) => setStage(res.data.data));
    getPercentage(currentStep);
  }, [currentStep]);

  const getPercentage = (currentStage: number) => {
    if (currentStage === 1 || currentStage === 23) {
      setPercentage(0);
    } else if (currentStage === 24) {
      setPercentage(10);
    } else if (currentStage === 25) {
      setPercentage(20);
    } else if (currentStage === 26) {
      setPercentage(30);
    }
  };

  return (
    <>
      <ProgressStyled>
        {stage?.map((item, i) => {
          return (
            <div key={`${i}+${item.name}`} className="circleContainer">
              <Circle
                stage={item.id}
                currentStage={currentStep}
                text={item.name}
                index={i + 1}
              />
            </div>
          );
        })}
        {/* <div className={(currentStep > 0) ? "line" : "lineActive"}></div> */}
        <ProgressLineStyled percentage={percentage}/>
      </ProgressStyled>
      <TextStyled>
        {stage?.map((item, i) => {
          return (
            <p
              key={`${i}+${item.name}`}
              className={currentStep >= item.id ? "textActive" : ""}
            >
              {item.name}
            </p>
          );
        })}
      </TextStyled>
    </>
  );
};


const ProgressLineStyled = styled.div<{ percentage: number }>`
  position: absolute;
  width: 75%;
  max-width: 520px;
  z-index: 1000;
  height: 5px;
  background: linear-gradient(
    to right,
    ${props => (props.percentage === 0) ? T.grayStepBar : T.primary} 0% 30%,
    ${props => (props.percentage <= 10) ? T.grayStepBar : T.primary} 30% 65%,
    ${props => (props.percentage <= 20) ? T.grayStepBar : T.primary} 40% 60%);
  @media (min-width: 480px) {
  position: absolute;
  width: 75%;
  max-width: 400px;
`;
